// extracted by mini-css-extract-plugin
export default {"pinningCursor":"game-find_pinningCursor__ZxhkR"};